import DOMPurify from 'dompurify';

import { replaceEmailTemplateVariables } from './replaceEmailTemplateVariables';

const EMAIL_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  's',
  'u',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'blockquote',
  'pre',
  'code',
  'hr',
  'a',
  'span',
];

const EMAIL_ALLOWED_ATTR = ['href', 'target', 'rel'];

export const HTML_EDITOR_PREVIEW_ALLOWED_TAGS = [
  ...EMAIL_ALLOWED_TAGS,
  'html',
  'head',
  'body',
  'meta',
  'title',
  'table',
  'tbody',
  'tr',
  'td',
  'div',
  'img',
  'b',
  'i',
  'strike',
];

export const HTML_EDITOR_PREVIEW_ALLOWED_ATTR = [
  ...EMAIL_ALLOWED_ATTR,
  'style',
  'role',
  'width',
  'cellpadding',
  'cellspacing',
  'align',
  'alt',
  'data-network',
  'class',
  'charset',
  'name',
  'content',
];

const HTML_EDITOR_DOCUMENT_PATTERN = /<table[^>]*role=["']presentation["']/i;

export const isHtmlEditorEmailDocument = (html: string | undefined): boolean => {
  if (!html?.trim()) {
    return false;
  }

  return HTML_EDITOR_DOCUMENT_PATTERN.test(html);
};

export const sanitizeEmailTemplateHtml = (value: string) =>
  DOMPurify.sanitize(value, {
    ALLOWED_TAGS: EMAIL_ALLOWED_TAGS,
    ALLOWED_ATTR: EMAIL_ALLOWED_ATTR,
  });

export const sanitizeHtmlEditorEmailHtml = (value: string) =>
  DOMPurify.sanitize(value, {
    WHOLE_DOCUMENT: true,
    ALLOWED_TAGS: HTML_EDITOR_PREVIEW_ALLOWED_TAGS,
    ALLOWED_ATTR: HTML_EDITOR_PREVIEW_ALLOWED_ATTR,
  });

export const prepareEmailBodyHtml = (raw: string | undefined): string => {
  if (!raw?.trim()) {
    return '';
  }

  return sanitizeEmailTemplateHtml(replaceEmailTemplateVariables(raw.trim()));
};

export const prepareEmailPreviewDocument = (raw: string | undefined): string => {
  if (!raw?.trim()) {
    return '';
  }

  return sanitizeHtmlEditorEmailHtml(replaceEmailTemplateVariables(raw.trim()));
};
